import { GET_JOB } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_JOB.LOAD:
      return {
        ...state,
        loading: true
      };
    case GET_JOB.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case GET_JOB.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
